var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgTechnicalPreviewMini(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, props),
        React.createElement("linearGradient", { id: 'technical-preview-mini-gradient', gradientUnits: 'userSpaceOnUse', x1: 8, x2: 8, y1: 16, y2: 0 },
            React.createElement("stop", { offset: 0, stopColor: '#ffc335' }),
            React.createElement("stop", { offset: 1, stopColor: '#ffdf52' })),
        React.createElement("path", { d: 'm8.7.3 7 7a.96667.96667 0 0 1 0 1.4l-7 7a.96667.96667 0 0 1 -1.4 0l-7-7a.96667.96667 0 0 1 0-1.4l7-7a.96667.96667 0 0 1 1.4 0', fill: 'url(#technical-preview-mini-gradient)' }),
        React.createElement("path", { d: 'm8 1 7 7-7 7-7-7zm0-1a.90783.90783 0 0 0 -.7.3l-7 7a.96667.96667 0 0 0 0 1.4l7 7a.96667.96667 0 0 0 1.4 0l7-7a.96667.96667 0 0 0 0-1.4l-7-7a.90783.90783 0 0 0 -.7-.3z', fill: '#ffc000' }),
        React.createElement("circle", { cx: 8, cy: 8, opacity: 0.9, r: 2, fill: '#000' })));
}
export default SvgTechnicalPreviewMini;
